export const DRAWER_LINKS = [
  // { to: "/", title: "Home", icon: "mdi-home-outline" },
  {
    to: "/manage",
    title: "Manage",
    icon: "mdi-folder-multiple-outline",
    children: [
      {
        to: "/manage/catalog",
        title: "Catalog",
        icon: "mdi-book-open-page-variant-outline"
      },
      {
        to: "/manage/brand",
        title: "Brand",
        icon: "mdi-fingerprint",
        isAllowed: $ =>
          !$.$store.getters.isContributor && !$.$store.getters.isViewer
      }
    ]
  },
  {
    to: "/manage-users",
    title: "Settings",
    icon: "mdi-cog",

    isAllowed: $ => {
      return $.$store.getters.isUserAdmin
    },
    children: [
      {
        to: "/manage-users",
        isAllowed: $ => {
          return $.$store.getters.isUserAdmin
        },
        title: "Manage users",
        icon: "mdi-account-group"
      },
      {
        to: "/merge-duplicates",
        isAllowed: $ => $.$store.getters.canMergeDuplicates,
        title: "Merge duplicates",
        icon: "mdi-merge"
      }
    ]
  }
]

export const BOTTOM_DRAWER_LINKS = [
  // {
  //   to: "/notifications",
  //   title: "Notifications",
  //   icon: "mdi-bell-outline"
  // }
]
